export default __webpack_public_path__ + "static/tintash-logo-white-fc93e56b54e8448f0ed1ebce0812dafd.svg";